module.exports = __webpack_public_path__ + "static/favicon-1e29dba0601e399b6090992fc0d91e64.png";